// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".paymentAllBanksButton[data-v-4ab6814e]{align-items:center;cursor:pointer;display:flex}.paymentAllBanksButton__ico[data-v-4ab6814e]{margin-right:12px}.paymentAllBanksButton__arrow[data-v-4ab6814e]{margin-left:auto}.novikov[data-v-4ab6814e]{color:#0a0a0a}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
